export interface ElaborationDocStatus {
  id: string;
  descrizione: string;
  label: string;
}

export enum ELABORATION_DOC_STATUS {
  INVIATO = 'inviato',
  ELABORATO = 'elaborato',
  ERRORE = 'errore'
}
